package it.neckar.lizergy.model.configuration.components

import it.neckar.lizergy.model.energy.PowerRating
import it.neckar.open.formatting.format
import it.neckar.open.i18n.CurrentI18nConfiguration
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.unit.si.kW
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class ExistingPVFacilityConfiguration(
  val id: ExistingPVFacilityConfigurationId,
  val zaehlernummer: String = "",
  val powerRating: PowerRating = PowerRating.Zero,
  val existingInverters: List<InverterDescription> = emptyList(),
  val einspeiseart: Einspeiseart = Einspeiseart.Ueberschuss,
  val integrateIntoFacility: Boolean = false,
  val facilityPassword: String = "",
) : HasUuid {

  override val uuid: Uuid
    get() = id.uuid

  fun format(): String {
    return buildString {
      appendLine("Bestehende PV-Anlage: $zaehlernummer [${powerRating.formatKiloWattPeak()}]")
      appendLine("Passwort: $facilityPassword")
    }
  }

  fun duplicate(mapOfOldToNewUuids: MutableMap<Uuid, Uuid>): ExistingPVFacilityConfiguration {
    val newId = ExistingPVFacilityConfigurationId.random()
    mapOfOldToNewUuids[id.uuid] = newId.uuid
    return copy(id = newId)
  }

  /**
   * An id for a [ExistingFacilitiesConfiguration]
   */
  @Serializable
  data class ExistingPVFacilityConfigurationId(val uuid: NativeUuid) {

    override fun toString(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): ExistingPVFacilityConfigurationId {
        return ExistingPVFacilityConfigurationId(randomUuid4())
      }
    }
  }

  companion object {
    fun getEmpty(id: ExistingPVFacilityConfigurationId = ExistingPVFacilityConfigurationId.random()): ExistingPVFacilityConfiguration {
      return ExistingPVFacilityConfiguration(id = id)
    }
  }

}


@Serializable
data class InverterDescription(
  val type: String = "",
  val power: @kW Double = 0.0,
) {
  fun format(i18nConfiguration: I18nConfiguration = CurrentI18nConfiguration): String {
    return "$type [${power.format(numberOfDecimals = 2, i18nConfiguration = i18nConfiguration)} kW]"
  }
}
